// @flow

import radio from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Radio';
import {
  createBecomeSolutionPartner,
  createReferralProgram,
  createCreatorAffiliate,
} from './questions';
import {
  createPartnerPortal,
  createAccountStatus,
  createBillingPayment,
  createOnboardingJourneys,
} from './existingAccount';
import {
  createCantSeeLeads,
  createHowToSubmit,
  createLeadRejected,
} from './leadSubmissions';

export const createSolutionPartnerProgram = () => ({
  value: 'solution-partner-program',
  label: 'Questions about the Zapier Solution Partner Program',
  child: radio({
    id: 'solutionpartnerquestions',
    label: 'General questions',
    items: [
      createBecomeSolutionPartner(),
      createReferralProgram(),
      createCreatorAffiliate(),
    ],
  }),
});

export const createExistingSolutionPartner = (isLoggedIn: boolean) => ({
  value: 'existing-solution-partner',
  label: 'Help with an existing Solution Partner account',
  child: radio({
    id: 'existingaccountquestions',
    label: 'Existing account',
    items: [
      createPartnerPortal(isLoggedIn),
      createAccountStatus(isLoggedIn),
      createBillingPayment(isLoggedIn),
      createOnboardingJourneys(isLoggedIn),
    ],
  }),
});

export const createLeadSubmissions = (isLoggedIn: boolean) => ({
  value: 'lead-submissions',
  label: 'Help with lead submissions and referrals',
  child: radio({
    id: 'leadsubmissionquestions',
    label: 'Lead submissions',
    items: [
      createCantSeeLeads(isLoggedIn),
      createHowToSubmit(isLoggedIn),
      createLeadRejected(isLoggedIn),
    ],
  }),
});
